module.exports = __webpack_public_path__ + "media/images/home-gina-rae-4d70b0fa34a24284743e74f4340a091b.jpg";